import { useCallback } from 'react';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { SectionBoundaryId, SectionId } from '../../types.tsx';

export type LinkTarget =
	| 'view'
	| 'viewWithFilter'
	| 'user'
	| 'issue'
	| 'link'
	| 'createProject'
	| 'projectDirectory'
	| 'relatedProject'
	| 'manageTypes'
	| 'inviteUser'
	| 'addIssueTypes'
	| 'createStatus';

export const useSectionAnalytics = (sectionId: SectionId, boundaryId: SectionBoundaryId) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireSectionAnalytics = useCallback(
		(
			target: LinkTarget,
			attributes?: {
				[key: string]: string | boolean | number;
			},
		) =>
			fireUIAnalytics(createAnalyticsEvent({}), 'item clicked', 'summarySection', {
				...attributes,
				sectionId,
				boundaryId,
				target,
			}),
		[sectionId, boundaryId, createAnalyticsEvent],
	);

	const fireOverviewCardAnalytics = useCallback(
		(
			target: LinkTarget,
			attributes?: {
				[key: string]: string | boolean | number;
			},
		) =>
			fireUIAnalytics(createAnalyticsEvent({}), 'link clicked', 'summaryOverviewCard', {
				...attributes,
				sectionId,
				boundaryId,
				target,
			}),
		[sectionId, boundaryId, createAnalyticsEvent],
	);

	return { fireSectionAnalytics, fireOverviewCardAnalytics };
};
